import type { PostMetricType } from '~publish/components/graphqlEnums'

/**
 * LinkedIn's API reports aggregated totals (nested replies folded into comments,
 * engagement on reshared copies folded into reactions) that don't match LinkedIn's
 * own analytics UI. We surface the metric's helper description on these two metrics
 * to set expectations, matching the tooltips Insights already shows.
 */
const INFO_METRIC_TYPES = new Set<PostMetricType>(['reactions', 'comments'])

export const shouldShowMetricInfo = (
  service: string,
  type: PostMetricType,
): boolean => service === 'linkedin' && INFO_METRIC_TYPES.has(type)
